import React, { useState } from "react";

import styles from './wallet.module.css';
import { useNavigate } from 'react-router-dom';
import { HeaderItem, StageHeader, Stages } from 'Components/shared/progress';
import { PinInput} from 'Components/main_components/transfer/reusables';
import { TransactionEnd} from 'Components/main_components/wallet/reusables';
import Hidden from "Components/shared/hidden";
import Back from "Components/main_components/registeration/Back";
import useForm from "hooks/useForm";
import Text from "Components/shared/text";
import { RouteAwareCrumbs } from "Components/shared/breadcrumbs";
import { DepositAmount, FundingInstruction, DepositSummary } from "Components/main_components/wallet/deposit";


const WalletDeposit = () => {
    const totalStages = 3;
    const navigate = useNavigate();
    const [stage, setStage] = useState(1);
    const [openModal, setOpenModal] = useState(false);
    const [errorState, setErrorState] = useState(null);
    
    const handleNext = () => {
        if (!(stage < totalStages))  return ;
        setStage(stage + 1);
    };
    const handlePrev = () => {
        if (!(stage > 1))  return ;
        setStage(stage - 1);
    };
    const handleComplete = (e, err,data) => {
        if(err){
            setErrorState(err)
        }
        setOpenModal(true)
    }
   
    const onSuccessHandler = () => {
        setOpenModal(false)
        navigate(-1);
    }

    //Form Related States
    const initialState ={
        amount: '',
    }
    const submitHandler = (values,errors, setSubmitting, setErrors) => {

    }
    const {handleSubmit, values, errors, isSubmitting, isValid, touched, handleUpdate, setValues} = useForm({initialState, submitHandler});
    const NameMap = {
        "/wallet":"Wallet",
        "/wallet/naira":"Naira Wallet",
        "/wallet/naira/deposit":"Deposit"
    }
    return(
        <div className={styles.root}>
            <div className={styles.Header}>
            <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>Deposit</Text>
            <RouteAwareCrumbs nameMap={NameMap} />
        </div>
            <form onSubmit={handleSubmit} className={`${styles.Deposit}`}>
                    <StageHeader currentStage={stage} totalStages={totalStages} className={styles.StageHeader} 
           left={stage >= 2 ?(
               <Hidden smDown>
                   <Back onClick={handlePrev} />
               </Hidden>
           ):null} >
                        <HeaderItem active={stage === 1} passed={stage > 1}>
                        Amount 
                        </HeaderItem>
                        <HeaderItem active={stage === 2} passed={stage > 2}>
                        Funding instructions
                        </HeaderItem>
                        <HeaderItem active={stage === 3} passed={stage > 3}>
                        Summary
                        </HeaderItem>
                    </StageHeader>
                    <Stages active={stage} values={values} setValues={setValues} errors={errors} touched={touched} handleUpdate={handleUpdate} >
                        <DepositAmount onNext={handleNext} onPrevious={() => navigate("../")} />
                        <FundingInstruction onNext={handleNext} onPrevious={handlePrev} />
                        <DepositSummary onNext={handleComplete} onPrevious={handlePrev} />
                    </Stages>
            </form>
                   
                    <TransactionEnd openModal={openModal} onClose={() =>  setOpenModal(false)} onSuccess={onSuccessHandler} success={!errorState} onError={() => setErrorState(null)} 
                    />
        </div>
    )
}

export default WalletDeposit;
